import React, { useState } from "react";

/** Color palette for token placeholder backgrounds - derived from symbol for consistency */
const PLACEHOLDER_COLORS = [
  "bg-blue-500",
  "bg-emerald-500",
  "bg-violet-500",
  "bg-amber-500",
  "bg-rose-500",
  "bg-cyan-500",
  "bg-orange-500",
  "bg-pink-500",
  "bg-indigo-500",
  "bg-teal-500",
];

const getPlaceholderColor = (symbol: string): string => {
  const char = symbol.charAt(0).toUpperCase();
  const index = char.charCodeAt(0) % PLACEHOLDER_COLORS.length;
  return PLACEHOLDER_COLORS[index];
};

interface TokenIconProps {
  symbol: string;
  logo?: string | null;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const sizeClasses = {
  sm: "w-6 h-6 text-xs",
  md: "w-10 h-10 text-base",
  lg: "w-16 h-16 text-xl",
};

export const TokenIcon: React.FC<TokenIconProps> = ({
  symbol,
  logo,
  size = "md",
  className = "",
}) => {
  const [hasError, setHasError] = useState(false);
  const showPlaceholder = !logo || hasError;

  const firstLetter = symbol.charAt(0).toUpperCase() || "?";
  const sizeClass = sizeClasses[size];

  if (showPlaceholder) {
    return (
      <div
        className={`flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white ${sizeClass} ${getPlaceholderColor(symbol)} ${className}`}
      >
        {firstLetter}
      </div>
    );
  }

  return (
    <img
      src={logo}
      alt={symbol}
      className={`${sizeClass} rounded-full flex-shrink-0 object-cover ${className}`}
      onError={() => setHasError(true)}
    />
  );
};
